"use strict";
export const TeamMock = (mock) => {
  mock.onGet("/api/v7/team_joined").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "model.team",
            "comment": "",
            "status": "pass",
            "team_name": "18712701715\u56E2\u961F",
            "team_id": "org_od113983055bc48b7b9d3801753227f3d",
            "team_choose": false,
            "vd_count": 0,
            "shop_count": 0,
            "account_no": "0001",
            "user_name": "\u90ED\u6DA6\u9716",
            "audit_time": 1614052183e3
          },
          {
            "model": "model.team",
            "comment": "",
            "status": "remove",
            "team_name": "13672021479\u56E2\u961F",
            "team_id": "org_oe2c8f1fae2e542e08ccfb13b1e3d848f",
            "team_choose": true,
            "vd_count": 1,
            "shop_count": 9,
            "account_no": "0079",
            "user_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
            "audit_time": 1615946114e3
          }
        ],
        "total": 2
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 2,
        "size": 10
      }
    };
    return [200, response];
  });
};
